module.exports = __webpack_public_path__ + "static/media/Gratitude.0d9fb795.mp3";